import { useEffect, useState } from "react";
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { Modal, Select } from "antd";
import { decrypt, getStoreType } from "../../../dynamicController";
import { saveOperatorId } from "../../../redux/actions/userActions";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { saveCreds, scannedCode } from "../../../redux/actions/paymentActions";

const mySwal = withReactContent(Swal);

const STORETYPE = getStoreType()

const UserLogin = ({ token, scanned, saveCredentials, saveOperatorId }) => {

    const { t } = useTranslation();
    const history = useHistory();

    const [loading, setLoading] = useState(false);
    const [number, setNumber] = useState("");
    const [outletList, setOutletList] = useState([]);
    const [outletId, setOutletId] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [userData, setUserData] = useState(null);
    const [name, setName] = useState("");

    useEffect(() => {
        if (!token) {
            history.push("/staff")
        } else {
            setLoading(true)

            axios.get("/api/staff/getOutlet", { headers: { "Content-Type": "application/json", "auth-token": token } })
                .then(res => {
                    let outletOptions = []
                    for (let i = 0; i < res.data.data.outlets.length; i++) {
                        let outletObject = {
                            value: res.data.data.outlets[i].id,
                            label: res.data.data.outlets[i].outlet_fullname
                        }
                        outletOptions.push(outletObject)
                    }

                    setOutletList(outletOptions)
                    setLoading(false)
                })
                .catch(err => {
                    setLoading(false)
                    mySwal.fire(t("Error"), t(err.response.data.error), "error");
                })
        }
    }, [])

    const handleSubmit = (e) => {
        e.preventDefault();

        const emailRegex = /^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/
        const numberRegex = /^\d+$/;

        if (!number || !outletId || !name) {
            mySwal.fire(t("Error"), t("Please fill in all the required fields before submit."), "error");
        } else if (number.includes("@") && !emailRegex.test(number)) {
            mySwal.fire(t("Error"), t("Invalid Email Address"), "error");
        } else if (!number.includes("@") && !numberRegex.test(number)) {
            mySwal.fire(t("Error"), t("Invalid Phone Number"), "error");
        } else {
            setLoading(true)

            axios.post("/api/staff/userLogin", { number }, { headers: { "Content-Type": "application/json", "auth-token": token } })
                .then(res => {
                    if (res.data.status === "FOUND") {
                        setUserData(res.data.data.user)
                    } else {
                        setUserData(null)
                    }
                    setOpenModal(true)
                    setLoading(false)
                })
                .catch(err => {
                    setLoading(false)
                    mySwal.fire(t("Error"), t(err.response.data.error), "error");
                })
        }
    }

    const registerNewUser = async () => {
        try {
            setLoading(true)
            let res = await axios.post("/api/staff/user/register", { outletId, number, name }, { headers: { "Content-Type": "application/json", "auth-token": token } })

            if (res.data.data) {
                setUserData(res.data.data.user)
                return res.data.data.user
            }

            return null
        } catch (err) {
            setLoading(false)
            mySwal.fire(t("Error"), t(err.response.data.error), "error");
            return null
        }
    }

    const redirectPaymentPage = async () => {
        let currentUser = userData

        if (!userData) {
            currentUser = await registerNewUser()
        }

        if (currentUser) {
            if (!outletId) {
                mySwal.fire(t("Error"), t("Please fill in all the required fields before submit."), "error");
            } else {
                setLoading(true)
                axios.post("/api/user/encrypt", { outletId })
                    .then(res => {
                        let sendThis = {
                            opId: res.data.operatorCode,
                            outletCode: res.data.outletCode,
                            operatorId: res.data.operatorId
                        }

                        if (res.data.operatorId) {
                            saveOperatorId(res.data.operatorId)
                        }

                        if (currentUser) {
                            sendThis.migrate_id = currentUser.migrate_id
                        }

                        axios
                            .post("/api/user/getDngPricing", sendThis)
                            .then(resp => {
                                const response = decrypt(resp.data.data)
                                scanned(response)
                                saveCredentials({ operatorCode: res.data.operatorCode, outletCode: res.data.outletCode })

                                let stateData = { role: "staff", name, userData: currentUser }
                                if (number.includes("@")) {
                                    stateData.email = number
                                } else {
                                    stateData.phone = number
                                }
                                history.push("/user/dng/payment", stateData)
                            })
                            .catch(err => {
                                setLoading(false)
                                mySwal.fire(t("Error"), t(err.response.data.error), "error");
                            })
                    })
                    .catch(err => {
                        setLoading(false)
                        mySwal.fire(t("Error"), t(err.response.data.error), "error");
                    })
            }
        }
    }

    return (
        <div>
            <div id="setting-page">
                <div id="setting-main" className="dng-outlet-selection">
                    <div id="user-header">
                        <h5>
                            <i
                                onClick={(e) => history.goBack()}
                                className="bi bi-chevron-left me-3"
                            ></i>{" "}
                            <strong>{t("Drop n Go Service")}</strong>
                        </h5>
                    </div>

                    <div id="user-body" style={{ paddingTop: "30px" }}>
                        <form onSubmit={handleSubmit}>
                            <div className="form-group px-5">
                                <input type="text" name="name" id="name" className="form-control browser-default" value={name} onChange={e => setName(e.target.value)} required placeholder={t("Name")} />
                            </div>

                            <div className="form-group px-5">
                                <input type="text" name="number" id="number" className="form-control browser-default" value={number} onChange={e => setNumber(e.target.value)} required placeholder={t("Phone Number / Email")} />
                            </div>

                            <div className="form-group px-5">
                                <Select
                                    allowClear
                                    className="select-input"
                                    style={{ width: "100%" }}
                                    placeholder={t("Select an outlet")}
                                    options={outletList}
                                    showSearch
                                    optionFilterProp="label"
                                    onChange={(value) => setOutletId(value)}
                                    value={outletId}
                                />
                            </div>

                            <div className="px-5">
                                {
                                    loading ? (
                                        <div className="text-center">
                                            <div
                                                className={STORETYPE === "cuci" ? "spinner-border text-warning" : "spinner-border text-primary"}
                                                role="status"
                                            >
                                                <span className="sr-only">Loading ...</span>
                                            </div>
                                        </div>
                                    ) : (
                                        <button
                                            id="submit-dng-staff-login"
                                            type="submit"
                                            className="btn big-button form-control mt-3"
                                        >
                                            {t("SUBMIT")}
                                        </button>
                                    )
                                }
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <Modal
                open={openModal}
                onCancel={() => setOpenModal(false)}
                footer={null}
                centered
                closable={false}
                maskClosable={false}
            >
                {
                    userData ? (
                        <div>
                            <h2 className="text-center">{t("User Found")}</h2>
                            <p className="text-center">{t("Are you sure you want to proceed payment?")}</p>
                            <p className="m-0 p-0">{t("Member ID")}: {userData.memberId}</p>
                            <p className="m-0 p-0">{t("Name")}: {userData.name}</p>
                            <p className="m-0 p-0">{t("Phone")}: {userData.number}</p>
                            <p>{t("Email")}: {userData.email}</p>
                        </div>
                    ) : (
                        <div className="text-center">
                            <h2>{t("User Not Found")}</h2>
                            <p className="m-0 p-0">{t("Are you sure you want to proceed and register new account?")}</p>
                        </div>
                    )
                }
                <div className="text-center">
                    <button
                        type="button"
                        className="btn btn-secondary cleanpro-swal-secondary-btn washup-swal-btn mx-1"
                        onClick={(e) => setOpenModal(false)}
                    >
                        {t("Cancel")}
                    </button>

                    {
                        loading ? (
                            <div className="text-center">
                                <div
                                    className={STORETYPE === "cuci" ? "spinner-border text-warning" : "spinner-border text-primary"}
                                    role="status"
                                >
                                    <span className="sr-only">Loading ...</span>
                                </div>
                            </div>
                        ) : (
                            <button
                                type="button"
                                className="btn btn-primary cleanpro-swal-btn washup-swal-btn"
                                onClick={(e) => redirectPaymentPage()}
                            >
                                {t("Proceed")}
                            </button>
                        )
                    }
                </div>
            </Modal>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        token: state.staff.token,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        scanned: data => dispatch(scannedCode(data)),
        saveCredentials: data => dispatch(saveCreds(data)),
        saveOperatorId: (id) => dispatch(saveOperatorId(id)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserLogin);